import type { ReservationStatus, ThreadAccountPostReservation } from '../../api/types';

export const activeReservationStatuses: ReservationStatus[] = ['PENDING', 'PROCESSING', 'READY', 'AWAITING_APPROVAL', 'PUBLISHING', 'PUBLISH_UNKNOWN', 'FAILED'];
// The reliability migration left these historical rows unresolved. Keep their server state,
// but separate them from current work and alerts on the board.
export const isLegacyReservation = (task: ThreadAccountPostReservation) =>
  (task.status === 'PUBLISH_UNKNOWN' || task.status === 'CANCELLED')
  && task.errorMessage?.trim() === '이전 버전 작업의 발행 결과를 Threads에서 확인하세요. 자동 재시도하지 않습니다.';
export const editableReservation = (task: ThreadAccountPostReservation) => task.status === 'READY' || task.status === 'AWAITING_APPROVAL'
  || (task.status === 'PENDING' && task.source === 'NOTION' && !task.notionAiRewrittenAt);
export function reservationStatusLabel(status: ReservationStatus) {
  const labels: Record<ReservationStatus, string> = {
    PENDING: '제작 대기', PROCESSING: '제작 중', READY: '발송 대기',
    AWAITING_APPROVAL: '승인 대기', PUBLISHING: '발송 중', PUBLISH_UNKNOWN: '발행 결과 확인 필요',
    DONE: '발행 완료', FAILED: '실패', CANCELLED: '보관됨',
  };
  return labels[status] ?? status;
}
